<template>
  <select
    name="mode-sigle"
    id="mode-sigle"
    :value="value"
    :required="required"
    @change="$emit(`update`, $event.target.value)"
  >
    <option value=""></option>
    <option value="=">=</option>
    <option value="lte">≤</option>
    <option value="gte">≥</option>
  </select>
</template>

<script>
export default {
  name: 'SignChoiceSelect',

  props: {
    value: String,
    required: Boolean
  }
}
</script>
